import { getStartTimeMappingCodes } from '../../containers/ActForm/UIOptimizations/PrefillStartTimeAccordingToCode/utils';

export const startTimeIsRequiredForCode = (code) => getStartTimeMappingCodes().includes(code);

export default startTimeIsRequiredForCode;
